//
// Test if some list or object or string or anything is empty-ish.
//
export const isEmpty = (o) =>
  o == null ||
  o === undefined ||
  (typeof o === 'string' && o.trim().length === 0) ||
  (Array.isArray(o) && o.length === 0) ||
  (typeof o === 'object' && Object.keys(o).length === 0)
